module.exports = __webpack_public_path__ + "AugmentedRealityandVirtualReality-55317aa7.webp";